export enum PageTypes {
    MAIN_PAGE = 1,
    PRODUCT_PAGE = 2,
    CATALOG_PAGE = 3,
    CART_PAGE = 4,
    CHECKOUT_PAGE = 5,
    THANK_YOU_PAGE = 6
}